import { render, staticRenderFns } from "./AddNewsDynamic.vue?vue&type=template&id=2280e146&scoped=true&"
import script from "./AddNewsDynamic.vue?vue&type=script&lang=js&"
export * from "./AddNewsDynamic.vue?vue&type=script&lang=js&"
import style0 from "./AddNewsDynamic.vue?vue&type=style&index=0&id=2280e146&scoped=scoped&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2280e146",
  null
  
)

export default component.exports